import React, { createContext, useContext, useEffect } from 'react';

// Subtítulo dinámico del navbar: una página puede comunicar en qué sub-vista
// está (ej. "Preparar Despacho") para que el navbar lo muestre como breadcrumb
// junto al label de la ruta (ej. "Terminal Bodega › Preparar Despacho").
// Opcionalmente expone una acción para volver a la raíz de la página (ej. salir
// del despacho y regresar a la lista) al tocar el label de la ruta en el navbar.
interface NavbarSubtituloApi {
  setSubtitulo: (sub: string) => void;
  setOnVolverRaiz: (fn: (() => void) | null) => void;
}

const NavbarSubtituloContext = createContext<NavbarSubtituloApi>({
  setSubtitulo: () => {},
  setOnVolverRaiz: () => {},
});

export function NavbarSubtituloProvider({
  api,
  children,
}: {
  api: NavbarSubtituloApi;
  children: React.ReactNode;
}) {
  return (
    <NavbarSubtituloContext.Provider value={api}>
      {children}
    </NavbarSubtituloContext.Provider>
  );
}

// Fija el subtítulo del navbar (y opcionalmente la acción "volver a la raíz")
// mientras `activo` sea true; limpia al desmontar o cuando `activo` pasa a false.
export function useNavbarSubtitulo(subtitulo: string, activo = true, onVolverRaiz?: () => void) {
  const { setSubtitulo, setOnVolverRaiz } = useContext(NavbarSubtituloContext);
  useEffect(() => {
    setSubtitulo(activo ? subtitulo : '');
    setOnVolverRaiz(activo && onVolverRaiz ? onVolverRaiz : null);
    return () => { setSubtitulo(''); setOnVolverRaiz(null); };
  }, [setSubtitulo, setOnVolverRaiz, subtitulo, activo, onVolverRaiz]);
}
